<div>
    <img src="assets/image/loader.gif" width="50px" class=""  >
</div>